var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 7.5,
    stroke: "#F7931A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3706 10C24.8214 10 25.1743 10.5638 24.9081 10.9693C23.0814 13.7469 21.3747 14.9159 19.548 17.6925C19.2808 18.099 18.7392 18.1042 18.472 17.6977C16.6453 14.9201 14.9322 13.7697 13.1055 10.991C12.9709 10.7872 12.976 10.5876 13.0596 10.4262C13.1351 10.1924 13.3411 10 13.6818 10L24.3706 10Z",
    fill: "#F7931A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3706 20C24.8214 20 25.1743 20.5638 24.9081 20.9693C23.0814 23.7469 21.3747 24.9159 19.548 27.6925C19.2808 28.099 18.7392 28.1042 18.472 27.6977C16.6453 24.9201 14.9322 23.7697 13.1055 20.991C12.9709 20.7872 12.976 20.5876 13.0596 20.4262C13.1351 20.1924 13.3411 20 13.6818 20L24.3706 20Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.beddd572673fed4777495e2b5aefb468.svg";
export { ForwardRef as ReactComponent };